import { z } from 'zod';

import { PortalPaymentStopSetting } from '../loan/StopSettings';

export const NonPerformanceSetting = z.strictObject({
  daysPastDue: z.int().positive(),
  emailsPaused: z.boolean(),
  documentAccessPaused: z.boolean(),
  portalPayments: PortalPaymentStopSetting,
});
export type NonPerformanceSetting = z.infer<typeof NonPerformanceSetting>;

export const CompanyNonPerformanceSettings = z.object({
  delinquent: NonPerformanceSetting,
  defaulted: NonPerformanceSetting,
});
export type CompanyNonPerformanceSettings = z.infer<typeof CompanyNonPerformanceSettings>;

export const DEFAULT_NON_PERFORMANCE_SETTINGS: CompanyNonPerformanceSettings = {
  delinquent: {
    daysPastDue: 31,
    emailsPaused: false,
    documentAccessPaused: false,
    portalPayments: 'any',
  },
  defaulted: {
    daysPastDue: 91,
    emailsPaused: true,
    documentAccessPaused: true,
    portalPayments: 'none',
  },
};

export const CompanyApplyDefaultInterestOnPastDueType = z.enum([
  'END_OF_GRACE', // Apply at end of grace period, start di on end of grace period
  'FIRST_OF_MISSED_CYCLE', // Apply on end of grace period, start di on first of missed cycle
  'FIRST_OF_MISSED_CYCLE_ON_FIRST_OF_NEXT_CYCLE', // Apply on first of next cycle, start di on first of missed cycle
]);
export type CompanyApplyDefaultInterestOnPastDueType = z.infer<typeof CompanyApplyDefaultInterestOnPastDueType>;

export const NonPerformanceAutomationDefaultInterestSetting = z.strictObject({
  applyOnPastDue: z.boolean(),
  applyOnPastDueType: CompanyApplyDefaultInterestOnPastDueType,
  applyOnMaturityDateAndNotPaidInFull: z.boolean(),
});
export type NonPerformanceAutomationDefaultInterestSetting = z.infer<
  typeof NonPerformanceAutomationDefaultInterestSetting
>;

export const CompanyNonPerformanceAutomationSettings = z.object({
  defaultInterest: NonPerformanceAutomationDefaultInterestSetting,
});

export type CompanyNonPerformanceAutomationSettings = z.infer<typeof CompanyNonPerformanceAutomationSettings>;

export const DEFAULT_NON_PERFORMANCE_AUTOMATION_SETTINGS: CompanyNonPerformanceAutomationSettings = {
  defaultInterest: {
    applyOnPastDue: false,
    applyOnPastDueType: 'FIRST_OF_MISSED_CYCLE',
    applyOnMaturityDateAndNotPaidInFull: false,
  },
};
